import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import DialogActions from "../../molecules/DialogActions/DialogActions";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions
        onCancel={onCancel}
        onConfirm={onConfirm}
        confirmText={confirmText}
        cancelText={cancelText}
      />
    </Dialog>
  );
};

export default ConfirmDialog;
